module.exports = __webpack_public_path__ + "img/only-background.7bcac63a.svg";